<template>
		<div id="pageRoot">

					<p id="text01" class="pageElement">
						¿QUÉ ES VENANCIO?
					</p>

					<p id="text02" class="pageElement">
						VUELA BAJITO PORQUE NO ES UN PÁJARO.<br>
						NO TIENE PLUMAS Y TIENE PELOS.<br> 
						CUANDO ESTÁ CONTENTO, MUEVE LA COLA.<br>
						SALUDA DICIENDO: ARF, ARF, ARF.
					</p>

					<div id="title" class="appearAnimationA">		
						<img src="/pages/img/sordo/svgPage51Title.svg" class="pageElement" style=" width: 100%; height: 100%;">
					</div>
					<div id="cloudGroup01" class="slideItem">		
						<img src="/pages/img/sordo/svgPage51CloudGroup01.svg" class="pageElement" style=" width: 100%; height: 100%;">
					</div>
					<div id="zorritoPlane" class="bouncingItem">		
						<img src="/pages/img/sordo/svgPage51ZorritoPlane.svg" class="pageElement" style=" width: 100%; height: 100%;">
					</div>
					<div id="tag">		
						<img src="/pages/img/sordo/svgPage51Tag.svg" class="pageElement" style=" width: 100%; height: 100%;">
					</div>
					<div id="cloudGroup02" class="slideItem">		
						<img src="/pages/img/sordo/svgPage51CloudGroup02.svg" class="pageElement" style=" width: 100%; height: 100%;">
					</div>

					<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
					<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
		</div>
</template>
<style scoped>
/* ¿QUÉ ES VENANCIO? */
#title
{
position: absolute;
left: 14.36%;
right: 12.78%;
top: 2.6%;
bottom: 89.03%;
}
#cloudGroup01
{
position: absolute;
width: 343.5px;
height: 215.71px;
left: 0px;
top: 110px;
animation-delay: 2s;
animation-duration: 5s;
}
#tag
{
position: absolute;
width: 761.98px;
height: 401.52px;
left: 246.03px;
top: 138.96px;
z-index: 4;
}
#zorritoPlane
{
position: absolute;
width: 479.27px;
height: 385.14px;
left: 114.22px;
top: 311.04px;
z-index: 5;
transform: rotate(11.3deg);
}
#cloudGroup02
{
position: absolute;
width: 481px;
height: 203px;
left: 529px;
top: 531px;
}
#text01 {
z-index: 5;
position: absolute;
width: 360px;
height: 49px;
left: 537px;
top: 166px;
margin: 0px;

font-family: Open Sans, sans-serif;
font-style: normal;
font-weight: bold;
font-size: 34px;
line-height: 49px;
letter-spacing: 1.1px;
/* identical to box height */

color: #000000;
}


/* VUELA BAJITO PORQUE NO ES UN PÁJARO. NO TIENE PLUMAS Y TIENE PELOS. CUANDO ESTÁ CONTENTO, MUEVE LA COLA. SALUDA DICIENDO: ARF, ARF, ARF. */
#text02 {
z-index: 5;
position: absolute;
width: 551px;
height: 172px;
left: 445px;
top: 230px;
margin: 0px;

font-family: Open Sans, sans-serif;
font-style: normal;
font-weight: normal;
font-size: 23px;
line-height: 36px;
text-align: center;
letter-spacing: 1.3px;

color: #000000;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["p51/V14.mp4"]
    };
  },
};
</script>